module.exports = __webpack_public_path__ + "static/media/familysiteimgmobile.f13ac6dd.png";